<script setup lang="ts">
import type { ToggleGroupRootEmits, ToggleGroupRootProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import type { PToggleGroupVariants } from './context.js';
import { reactiveOmit } from '@vueuse/core';
import { ToggleGroupRoot, useForwardPropsEmits } from 'reka-ui';
import { provide, toRef } from 'vue';
import { cn } from '@ui/lib/utils.js';
import { pToggleGroupContextKey } from './context.js';

const props = withDefaults(
    defineProps<
        ToggleGroupRootProps & {
            class?: HTMLAttributes['class'];
            variant?: PToggleGroupVariants['variant'];
            size?: PToggleGroupVariants['size'];
            spacing?: number;
            rounded?: boolean;
        }
    >(),
    {
        spacing: 0,
    },
);

const emits = defineEmits<ToggleGroupRootEmits>();

provide(pToggleGroupContextKey, {
    variant: toRef(props, 'variant'),
    size: toRef(props, 'size'),
    spacing: toRef(props, 'spacing'),
    rounded: toRef(props, 'rounded'),
});
const delegatedProps = reactiveOmit(props, 'class', 'size', 'variant', 'rounded', 'spacing');
const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
    <ToggleGroupRoot
        v-slot="slotProps"
        data-slot="toggle-group"
        :data-size="size"
        :data-variant="variant"
        :data-spacing="spacing"
        :style="{
            '--gap': spacing,
        }"
        v-bind="forwarded"
        :class="cn('group/toggle-group flex w-fit items-center gap-[--spacing(var(--gap))] rounded-lg', props.class)"
    >
        <slot v-bind="slotProps" />
    </ToggleGroupRoot>
</template>
